import React from 'react'

/**
 * In order to allow FullStory to record labels, we need to wrap them with a div that has the class
 * name "fs-unmask".
 * @param param0 A react node to wrap with FullStory unmask div element
 * @returns The wrapped react node
 */
const FullStoryUnmask = ({ children }: React.PropsWithChildren) => {
  return <div className="fs-unmask">{children}</div>
}

export { FullStoryUnmask }
